import React, { useEffect } from "react";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import { useValidateReload } from "hooks/useValidateReload";
import { useDispatch, useSelector } from "react-redux";
import { useSearch } from "hooks/useSearch";
import BalanceIcon from '@mui/icons-material/Balance';
import { handleErpEquivalenciesInputsAction, getErpEquivalenciesAction } from "redux/actions/erpEquivalencies/erpEquivalenciesActions";
import { columns } from "./columns";

const tableKey = "erpEquivalencies";
const loadings = [
  "loadingErpEquivalencies",
  "loadingModErpEquivalencies",
  "loadingErpCreditConditions",
  "loadingErpShipToAddress",
];

export const ErpEquivalenciesView = () => {
  const dispatch = useDispatch();
  const { erpEquivalencies, station } = useSelector(({ erpEquivalencies }) => erpEquivalencies);
  const { buildCompLoadings, buildTableConfig, setSnackbar } = useSearch();
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);

  const handleSubmit = (e) => {
    e.preventDefault()
    if (station?.length === 0) {
      setSnackbar("Falta seleccionar planta")
      return
    }
    dispatch(getErpEquivalenciesAction(station.id))
  };

  useValidateReload(loadings);

  useEffect(() => {
    buildCompLoadings(loadings);
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, []);

  return (
    <CardTable
      data={erpEquivalencies}
      columns={columns}
      hasHeader
      blockBtn
      title="Clientes de Crédito"
      icon={<BalanceIcon />}
      isLoading={isLoadingComp?.loadingErpEquivalencies}
      tableContent={
        <TableInputs
          reducer="erpEquivalencies"
          stations
          dispatchAction={handleErpEquivalenciesInputsAction}
          submitAction={handleSubmit}
        />
      }
      tableKey={tableKey}
    />
  );
};